import { request } from "../../platform/apiClient/apiRequest";
import type { SpeakUpMessage } from "../types/speakUp.types";

export const speakUpClient = {
  submit: (message: string, isAnonymous: boolean) =>
    request<SpeakUpMessage>("/speakup", {
      method: "POST",
      body: JSON.stringify({ message, isAnonymous }),
    }),

  getAdminMessages: () => request<SpeakUpMessage[]>("/speakup/admin"),

  deleteMessage: (id: string) => request<void>(`/speakup/admin/${encodeURIComponent(id)}`, { method: "DELETE" }),

  reply: (id: string, reply: string) =>
    request<SpeakUpMessage>(`/speakup/admin/${encodeURIComponent(id)}/reply`, {
      method: "PATCH",
      body: JSON.stringify({ reply }),
    }),
};
